// let link = "http://127.0.0.1:8000/api";
// let base_link = "http://127.0.0.1:8000";
let link = "https://collidebackend.globalsparks.live/api";
let base_link = "https://collidebackend.globalsparks.live";

const apilink = {
  link,
  base_link
};

export default apilink;
